import type { HTMLAttributes } from "react";
import { classNames } from "@app/utils/classNames";

type PillTone = "accent" | "success" | "warning" | "danger" | "neutral";

type PillProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: PillTone;
};

export function Pill({ tone = "neutral", className, ...rest }: PillProps) {
  return (
    <span
      {...rest}
      className={classNames("ui-pill", `ui-pill--${tone}`, className)}
    />
  );
}

